import { useState, useEffect, FC } from 'react'
import dynamic from 'next/dynamic'

const BannerAuthWarning = dynamic(
  () => import('components/banners/banner-auth-warning/banner-auth-warning')
)
import BreadcrumbsPage from 'components/parts/breadcrumb-page/breadcrumb-page'
import WebinarSearch from 'components/search/webinar-search/webinar-search'
import SwitchToggle from 'components/parts/switch-toggle/switch-toggle'
import SearchFilterContext from 'context/searchFilterContext'
import { useAuth } from 'store/auth/useAuth'
import useLectures from 'store/lists/useLectures'
import useThemes from 'store/lists/useThemes'
import useSpecialities from 'store/lists/useSpecialities'
import usePCWindow from 'hooks/usePCWindow'
import useWebinarSelectedOption from './useWebinarSelectedOption'

import { URL_SITE } from 'constants/data'
import { ScreenSize } from 'constants/media-constanst'
import { FilterIndex } from 'constants/search-data/search-data'
import {
  options,
  unAuthOptions,
  OptionAliases,
  optionsLinks,
} from 'constants/search-data/webinar-search-data'
import { IOptions } from 'constants/types/common.types'
import { INewslineCard, IWebinarCard } from 'constants/types/card.types'

import styles from 'components/search/webinar-search/webinar-search.module.scss'
import { originRegWebinars, A_LOG_REG_HASH } from 'utils/analytics/other/registration/registration'

interface IWebinarSearchLayout {
  title?: string
  targetInitParams?: IOptions
  initCards?: {
    count: number
    rows: INewslineCard[] | IWebinarCard[]
  }
}

const WebinarSearchLayout: FC<IWebinarSearchLayout> = ({
  title = 'Вебинары',
  targetInitParams,
  initCards,
  children,
}) => {
  const [filterState, setFilterState] = useState(FilterIndex.TURN_OFF_INDEX)

  const { isAuthorized, isNotAuthorized } = useAuth()
  const themes = useThemes()
  const lectures = useLectures()
  const specialities = useSpecialities()
  const { selectedOption, setSelectedOption } = useWebinarSelectedOption(OptionAliases)
  const isBigPC = usePCWindow(ScreenSize.big)

  const GAHandler = () => {
    sessionStorage.setItem(A_LOG_REG_HASH, originRegWebinars.LOGIN)
  }
  const setFilter = (filter?: number) => {
    if (!filterState) return setFilterState(FilterIndex.TURN_ON_INDEX)
    if (typeof filter === 'number') return setFilterState(Number(filter))
    if (filterState > FilterIndex.TURN_ON_INDEX) return setFilterState(FilterIndex.TURN_ON_INDEX)
    return setFilterState(FilterIndex.TURN_OFF_INDEX)
  }
  const providerValues = { filterState, setFilter }
  const isTarget = Boolean(targetInitParams)
  const filteredOptions = isAuthorized && !isTarget ? options : unAuthOptions

  useEffect(() => window?.scrollTo(0, 0), [])

  return (
    <>
      {children}
      <SearchFilterContext.Provider value={providerValues}>
        <WebinarSearch
          lectures={lectures}
          themes={themes}
          specialities={specialities}
          selectedOption={selectedOption}
          isBigPC={isBigPC}
          targetInitParams={targetInitParams}
          setSelectedOption={setSelectedOption}
          initCards={initCards}
        >
          <div>
            <div className={styles.breadcrumb}>
              <BreadcrumbsPage
                breadData={[{ name: 'Вебинары', link: `${URL_SITE}/webinar` }]}
              ></BreadcrumbsPage>
            </div>

            <h1 className={styles.titleFirst} dangerouslySetInnerHTML={{ __html: title }} />
            {isNotAuthorized && (
              <div className={styles.bannerAuth} onClick={GAHandler}>
                <BannerAuthWarning />
              </div>
            )}
            <div className={styles.switchToggleWrapper}>
              <SwitchToggle
                options={filteredOptions}
                selectedOption={selectedOption}
                handleToggle={setSelectedOption}
                optionsLinks={optionsLinks}
              />
            </div>
          </div>
        </WebinarSearch>
      </SearchFilterContext.Provider>
    </>
  )
}

export default WebinarSearchLayout
